import { AnyAction, Reducer } from 'redux';
import {
  CommonInsuranceData,
  GlobalAction,
  GlobalActions,
  isAzam,
  ProduktDeleted,
  ReplaceState,
  updateStateWithCommonInsuranceInfo,
  WrappedSavedStates,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import cloneDeep from 'lodash/cloneDeep';
import { Zahlungsart } from '@ps20/bff-models';
import {
  migrateAktionsnachlassAktion10, migrateAngebotsdatum,
} from '@ps20-frontend/migrations';
import { INITIAL_STATE } from '../initialState';
import { IAppState } from '../appState';
import { loadAndMigrateTkvState } from '../migrations';

export const rootReducer =
  (reducer: Reducer) =>
  (state: IAppState, action: AnyAction): IAppState => {
    switch (action.type) {
      case GlobalActions.SAVED_STATES_LOADED: {
        const newState = cloneDeep(state);
        const actionPayload: WrappedSavedStates = (action as GlobalAction<WrappedSavedStatesLoaded>)
          .payload.savedStatesLoaded;
        const loadedAppState = actionPayload.find(
          loadedState =>
            loadedState.appId === App.TKV &&
            loadedState.angebotsId === state.angebotsId &&
            loadedState,
        );

        if (loadedAppState != null) {
          if (isAzam(newState.transientState.role)) {
            delete loadedAppState.state.risikoort;
            delete loadedAppState.state.versicherungsnehmer.geburtsdatum;
            if (newState.vertragsoptionen?.zahlungsart === Zahlungsart.MAKLER_INKASSO) {
              delete loadedAppState.state.vertragsoptionen.zahlungsart;
            }
          }
          migrateAngebotsdatum(loadedAppState.state);
          migrateAktionsnachlassAktion10(
            loadedAppState.state,
            newState.transientState.featureToggles,
          );
          return loadAndMigrateTkvState(
            newState,
            loadedAppState.state,
            loadedAppState.state.vertragsoptionen?.beibehalten,
          );
        } else {
          return state;
        }
      }
      case GlobalActions.PRODUKT_DELETED: {
        const actionPayload: ProduktDeleted = action.payload;
        if (
          actionPayload.angebotsIds.some(
            angebot => angebot.appId === App.TKV && angebot.angebotsId === state.angebotsId,
          )
        ) {
          const newState = cloneDeep(INITIAL_STATE);
          newState.versicherungsnehmer.isAssekuranztarif =
            state.versicherungsnehmer.isAssekuranztarif;
          return newState;
        }
        return state;
      }
      case GlobalActions.REPLACE_STATE: {
        const actionPayload: ReplaceState<IAppState> = action.payload;
        if (actionPayload.appId === App.TKV && actionPayload.angebotsId === state.angebotsId) {
          return actionPayload.appState;
        }
        return state;
      }
      case GlobalActions.ANGEBOTS_ID_RECEIVED: {
        return {
          ...state,
          angebotsId: action.payload,
        };
      }
      case GlobalActions.COMMON_INSURANCE_DATA_RECEIVED: {
        const actionPayload: CommonInsuranceData = action.payload;
        return updateStateWithCommonInsuranceInfo(actionPayload, state, App.TKV);
      }
      default:
        return reducer(state, action);
    }
  };
